import styled from 'styled-components';

export const IconWrapperSpan = styled.span<{
  padding?: string;
  alignItems?: string;
}>`
  display: inline-flex;
  padding: ${(props): string => props.padding ?? 'unset'};
  align-items: ${(props): string => props.alignItems ?? 'center'};
`;
